import {Component, HostListener} from '@angular/core';
import {isStandardsPhone} from './standards-viewport';

@Component({
  selector: 'app-my-standards-catalog',
  template: '<app-phone-standards *ngIf="isPhone"></app-phone-standards>' +
    '<app-my-standards *ngIf="!isPhone"></app-my-standards>'
})
export class MyStandardsCatalogComponent {
  isPhone = isStandardsPhone();

  @HostListener('window:resize') updateViewport(): void { this.isPhone = isStandardsPhone(); }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/my-standards/my-standards-catalog.component.ts